<template lang="pug">
v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    label='Atlas Base Url'
    data-track="atlasBaseUrl"
    dense clearable outlined required)
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputAtlasBaseUrl extends Vue {}
</script>
